import { ResponsiveContainer, BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, LabelList } from "recharts";
import { useT } from "../../contexts/LanguageContext";

const DIFF_COLORS = { easy: "#059669", medium: "#D97706", hard: "#E11D48" };

export default function AccuracyByDifficulty({ data }) {
  const { t, tDiff } = useT();
  const rows = (data || []).map((d) => ({
    difficulty: tDiff(d.difficulty),
    key: d.difficulty,
    accuracy: d.accuracy,
    attempted: d.attempted,
    correct: d.correct,
    color: DIFF_COLORS[d.difficulty],
  }));
  return (
    <div className="card lg:col-span-4" data-testid="accuracy-by-difficulty">
      <div className="overline">{t("analytics.acc_diff_overline")}</div>
      <h3 className="font-display text-xl font-semibold mt-1">{t("analytics.acc_diff_title")}</h3>
      <div className="h-52 mt-3" style={{ minHeight: 200 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={rows} layout="vertical" margin={{ left: 12, right: 32, top: 8, bottom: 8 }}>
            <CartesianGrid stroke="#E2E8F0" strokeDasharray="3 3" horizontal={false} />
            <XAxis type="number" domain={[0, 100]} stroke="#64748B" fontSize={11} />
            <YAxis dataKey="difficulty" type="category" stroke="#64748B" fontSize={12} width={55} />
            <Tooltip
              contentStyle={{ background: "#0F172A", border: "none", borderRadius: 6, color: "#fff", fontSize: 12 }}
              formatter={(v, _n, { payload }) => [`${v}% (${payload.correct}/${payload.attempted})`, t("results.score")]}
            />
            <Bar dataKey="accuracy" radius={[0, 4, 4, 0]}>
              {rows.map((r) => <Cell key={r.key} fill={r.color} />)}
              <LabelList dataKey="accuracy" position="right" formatter={(v) => `${v}%`} fill="#0F172A" fontSize={11} />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
